import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useRef } from 'react';
import useRovingMessageList from 'flow/hooks/useRovingMessageList';

/**
 * Holds the message a thread belongs to, above the replies. It is a message
 * row like the ones in the lists, so it runs the same list hook over itself:
 * Tab reaches it, it is announced, and Enter opens its controls.
 */
import { jsx as _jsx } from "react/jsx-runtime";
var ThreadParentMessage = function ThreadParentMessage(_ref) {
  var children = _ref.children;
  var ref = useRef(null);
  var rovingHandlers = useRovingMessageList(ref);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    ref: ref
  }, rovingHandlers), {}, {
    children: children
  }));
};
export default ThreadParentMessage;